import { dataLock } from "@/data/DataUtils.ts";
import { Product } from "@/data/Product.ts";
import { Image, ImageType } from "@/data/Image.ts";
import uuid from "time-uuid";

export async function migrateImageUrl() {
  await dataLock.acquireAsync();
  const productsRaw = await Product.find({ selector: { image: { $exists: true } } }).exec();
  const products = productsRaw?.map(p => p.toMutableJSON());
  if (!products?.length) return
  const images = []
  for (const p of products) {
    if (p.imageUrl) {
      const randomId = uuid()
      images.push({
        _id: randomId,
        data: p.imageUrl,
        type: ImageType.ProductImage,
      })
      p.imageId = randomId;
    }
    delete p.image;
    delete p.imageUrl;
  }
  if (images?.length) {
    await Image.bulkUpsert(images)
    await Product.bulkUpsert(products)
    console.log(`updated ${images.length} images`)
  }
}